export default "__VITE_ASSET__fa9b7ab9__"